<template>
  <div class="video-item" :class="{ 'is-active': value === video.id }" @click="$emit('input', video.id)">
    <span class="el-icon-success"></span>
    <div class="video-thumb">
      <video :src="video.url"></video>
      <span class="play-btn el-icon-video-play" @click.stop="playVideos()"></span>
    </div>
    <div class="video-info">
      <el-tooltip effect="dark" :content="video.name" placement="top">
        <p class="video-title">{{ video.name }}</p>
      </el-tooltip>

      <p class="match-percent">{{ video.score }}匹配</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { MessageBox } from 'element-ui'
// eslint-disable-next-line
const props = defineProps({
  value: {
    type: [Number, String]
  },
  video: {
    type: Object,
    default: () => {}
  }
})

function videoPause() {
  const video = document.querySelector('.video-preview')
  video?.pause()
}

function playVideos() {
  MessageBox.alert(
    `<div style="width:100%;text-align:center;"><video class="video-preview" src="${props.video.url}" style="max-height: 320px; width:100%" controls="controls" autoplay="autoplay"></video></div>`,
    '素材预览',
    {
      dangerouslyUseHTMLString: true
    }
  )
    .catch(() => {
      videoPause()
    })
    .then(() => {
      videoPause()
    })
}
</script>

<style scoped lang="scss">
@import '~common/styles/element-ui/variables.scss';

.video-item {
  display: flex;
  flex-direction: column;

  position: relative;
  min-width: 106.66666666px;
  width: 106.66666666px;
  text-align: center;
  margin-right: 5px;
  border-radius: 4px;
  border: 2px solid #f5f5f5;
  overflow: hidden;
  padding: 2px;
  cursor: pointer;

  &:hover,
  &.is-active {
    border: 2px solid $primary-color;
    background: rgb(243, 248, 251);
  }
  &.is-active {
    .el-icon-success {
      display: block;
    }
  }

  .el-icon-success {
    display: none;
    position: absolute;
    top: 8px;
    left: 8px;
    font-size: 14px;
    color: $primary-color;
    z-index: 3;
  }
  .video-thumb {
    height: 60px;
    position: relative;

    &:hover {
      .play-btn {
        display: block;
      }
    }

    .play-btn {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      font-weight: 800;
      color: #fff;
      z-index: 2;
      cursor: pointer;
      opacity: 0.88;
    }
  }

  .video-info {
    line-height: 16px;

    .video-title {
      font-weight: 700;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .match-percent {
      color: $primary-color;
      font-size: 12px;
    }
  }
  video {
    // height: 60px;
    max-width: 100%;
    max-height: 60px;
    font-size: 0;
  }
}
</style>
